import PodcastClipThumbnail from './PodcastClipThumbnail';

export default PodcastClipThumbnail;
